import { render, staticRenderFns } from "./inspecao.vue?vue&type=template&id=74f588fb&scoped=true"
import script from "./inspecao.vue?vue&type=script&lang=js"
export * from "./inspecao.vue?vue&type=script&lang=js"
import style0 from "./inspecao.vue?vue&type=style&index=0&id=74f588fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f588fb",
  null
  
)

export default component.exports